import React, { useEffect } from 'react';

export const useIntersectionObserver = (
  ref: React.RefObject<Element | null>,
  onIntersect: () => void,
) => {
  useEffect(
    () => {
      let observer: IntersectionObserver | null = null;
      if (ref.current) {
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            onIntersect();
          }
        });
        observer.observe(ref.current);
      }
      return () => {
        observer?.disconnect();
      };
    },
    // without ref.current the callback is not triggered in some cases
    [ref, ref.current, onIntersect], // eslint-disable-line react-hooks/exhaustive-deps
  );
};
